/**
 * Caution: Consider this file when using react-scripts
 * 
 * You may delete this file and its occurrences from the project filesystem if you are using GatsbyJS or NextJS version
 */
import React, { useEffect } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import Routes from './Routes';
import { trackPageView } from 'utils/analytics';

import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'leaflet/dist/leaflet.css';
import 'assets/css/index.css';

import 'swiper/css/swiper.min.css';
import 'aos/dist/aos.css';



const browserHistory = createBrowserHistory();

const App = () => {
  useEffect(() => browserHistory.listen(trackPageView), []);

  return (
    <Router history={browserHistory}>
      <Routes />
    </Router>
  );
}

export default App;
